var map = {
	"./portfolio-1.jpg": 665,
	"./portfolio-1.webp": 666,
	"./portfolio-10.webp": 667,
	"./portfolio-11.webp": 668,
	"./portfolio-12.jpg": 669,
	"./portfolio-2.jpg": 670,
	"./portfolio-2.webp": 671,
	"./portfolio-3.jpg": 672,
	"./portfolio-3.webp": 673,
	"./portfolio-4.jpg": 674,
	"./portfolio-4.webp": 675,
	"./portfolio-5.jpg": 676,
	"./portfolio-5.webp": 677,
	"./portfolio-6.jpg": 678,
	"./portfolio-6.webp": 679,
	"./portfolio-7.jpg": 680,
	"./portfolio-8.webp": 681,
	"./portfolio-9.webp": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 862;